(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Unavailability', function($resource) {
        return $resource(
            'api/unavailabilities',
            {},
            {
                query: { method: 'GET', isArray: false }
            }
        );
    });
})();
